export default __webpack_public_path__ + "static/media/005-clock.2ebac6ca.svg";